export enum ImageConfig {
  default = 'default',
  noImage = 'noImage',
  custom = 'custom',
  fullReplace = 'fullReplace'
}

export enum SERVICE_PROVIDER {
  clover = 'CLOVER',
  square = 'SQUARE'
}
